/* eslint-disable no-unused-vars */
/* eslint-disable no-const-assign */
import React, {useEffect, useState} from 'react';
import {
  Button,
  Block,
  BlockBetween,
  BlockHead,
  BlockTitle,
  Icon,
  UserAvatar,
} from '../../components/Component';

import {Modal, ModalBody, FormGroup} from 'reactstrap';
import {Col, Row, RSelect} from '../../components/Component';
import GetStatus from '../helpers/getstatus';
import {findUpper} from '../../utils/Utils';

import Swal from 'sweetalert2';
const Status = ({po, update, setupdate, rol}) => {
  const [addDespachoText, setAddDespachoText] = useState('');
  const [addStatusModal, setStatusModal] = useState(false);
  const [EditStatusModal, setEditStatusModal] = useState(false);

  const statuses = [];
  GetStatus().then((resp) => {
    resp.forEach((element) => {
      statuses.push({value: element[0], label: element[1]});
    });
  });

  // const data = useGetNotas(idcliente);

  //Editar contenido de la nota
  const editstatus = () => {
    setEditStatusModal(false);
  };

  return (
    <React.Fragment>
      <Block>
        <div className="user-info">
          <div className="badge  ucap badge-danger"></div>
          {/* <span className="text-ssbnaranja"> {update.status}</span>{" "} */}

          {/*rol.some((role) =>
            ['maintainer', 'operator'].includes(role.toLowerCase())
          ) && (
            <div className="p-2">
              <div className="mt-4 mb-4">
                <FormGroup>
                  <label
                    className="form-label"
                    htmlFor="contact-name"
                  >
                    Order Status
                  </label>
                  <RSelect
                    options={statuses}
                    placeholder={update ? update.status : null}
                    defaultValue={update ? update.statusid : null}
                    onChange={(e) => {
                      setupdate({
                        ...update,
                        satusid: e.value,
                        status: e.label,
                      });
                      // UpdatesStatus(po, e.value).then(() => {
                      //   Swal.fire({
                      //     position: "top-end",
                      //     icon: "success",
                      //     title: "Your work has been saved",
                      //     showConfirmButton: false,
                      //     timer: 1500,
                      //   }).then(() => setEditStatusModal(false));
                      // });
                    }}
                    name="bg"
                  />
                </FormGroup>
              </div>
            </div>
          )*/}
            <div className="p-2">
              <div className="mt-4 mb-4">
                <FormGroup>
                  <label
                    className="form-label"
                    htmlFor="contact-name"
                  >
                    Order Status
                  </label>
                  <RSelect
                    options={statuses}
                    placeholder={update ? update.status : null}
                    defaultValue={update ? update.statusid : null}
                    onChange={(e) => {
                      setupdate({
                        ...update,
                        satusid: e.value,
                        status: e.label,
                      });
                      // UpdatesStatus(po, e.value).then(() => {
                      //   Swal.fire({
                      //     position: "top-end",
                      //     icon: "success",
                      //     title: "Your work has been saved",
                      //     showConfirmButton: false,
                      //     timer: 1500,
                      //   }).then(() => setEditStatusModal(false));
                      // });
                    }}
                    name="bg"
                  />
                </FormGroup>
              </div>
            </div>
        </div>
      </Block>

      
    </React.Fragment>
  );
};

export default Status;
